<template>
  <li
    class="zm-dropdown-menu__item"
    :class="{
      'is-disabled': disabled,
      'zm-dropdown-menu__item--divided': divided,
      'is-hover':hover
    }"
    @click="handleClick"
    :aria-disabled="disabled"
    :id="itemId"
    role="menuitem"
    :aria-label="ariaLabel"
    ref="item"
  >
    <i :class="icon" v-if="icon"></i>
    <slot></slot>
  </li>
</template>
<script>
  import Emitter from '../../mixins/emitter';

  let _uid = 0;

  export default {
    name: 'ZmDropdownItem',

    mixins: [Emitter],

    props: {
      command: {},
      disabled: Boolean,
      divided: Boolean,
      icon: String,
      ariaLabel: String
    },

    data() {
      return {
        hover: false
      };
    },

    computed: {
      listId() {
        return this.dropdown.listId;
      },
      itemId() {
        return `dropdown_item_${this.listId}-${_uid++}`;
      }
    },

    inject: ['dropdown'],

    created() {
      this.dropdown.options.push(this);
    },

    beforeDestroy() {
      const index = this.dropdown.options.indexOf(this);
      if (index > -1) {
        this.dropdown.options.splice(index, 1);
      }
    },

    methods: {
      handleClick(e) {
        if (this.disabled) {
          return;
        }
        this.dispatch('ZmDropdown', 'menu-item-click', [this.command, this]);
      }
    }
  };
</script>

<style lang="scss">
  @import "../../scss/mixins/mixins";
  @import "../../scss/common/var";

  @include b(dropdown-menu) {
    @include e(item) {
      list-style: none;
      line-height: 24px;
      padding: 4px 16px;
      margin: 0;
      font-size: $--font-size-base;
      color: $--color-text-secondary;
      cursor: pointer;
      outline: none;
      &:not(.is-disabled):hover, &:focus, &.is-hover {
        color: $--color-text-primary;
        background-color: $--background-color-hover;
      }
      &:not(.is-disabled):active {
        color: $--color-text-primary;
        background-color: $--background-color-pressed;
      }

      @include m(divided) {
        $divided-offset: 6px;

        position: relative;
        margin-top: $divided-offset;
        border-top: 1px solid $--border-color-lighter;

        &:before {
          content: '';
          height: $divided-offset;
          display: block;
          position: absolute;
          margin: 0 -$--input-default-padding-horizontal;
          background-color: $--color-white;
        }
      }

      @include when(disabled) {
        cursor: not-allowed;
        color: $--color-text-disabled;
      }
      a {
        color: $--color-text-primary;
        font-size: 14px;
      }
    }
  }
  @media (forced-colors: active) {
    .zm-dropdown-menu__item:not(.is-disabled):hover,
    .zm-dropdown-menu__item:focus,
    .zm-dropdown-menu__item.is-hover {
      outline: dotted thin !important;
      outline-offset: -4px;
    }
  }
</style>
